module.exports = __webpack_public_path__ + "img/nms.eacae949.jpg";